module.exports = __webpack_public_path__ + "media/backgrounds/wod_background2-5fe1eacd.png";